import { useEffect } from 'react'

import { PLAY_INTERVAL_MS } from './constants'
import { useLatest } from './useLatest'

export const usePlayback = (playing: boolean, tick: () => Promise<boolean>) => {
  const latestTick = useLatest(tick)
  useEffect(() => {
    if (!playing) return
    let cancelled = false
    let timer = 0
    const schedule = () => {
      timer = window.setTimeout(async () => {
        if (cancelled) return
        const more = await latestTick.current()
        if (more && !cancelled) schedule()
      }, PLAY_INTERVAL_MS)
    }
    schedule()
    return () => {
      cancelled = true
      window.clearTimeout(timer)
    }
  }, [latestTick, playing])
}
